import { initResetPassword as ssoInitResetPassword, changePassword as ssoChangePassword } from "@carnet/api/auth";

const ssoServer = () => useRuntimeConfig().public.SSO_SERVER;

export const initResetPassword = (identifier: string) => ssoInitResetPassword(ssoServer(), identifier);

export const changePassword = (userId: string, password: string, code: string) => ssoChangePassword(ssoServer(), userId, password, code);
